import { render, staticRenderFns } from "./TopfansBrightpoint.vue?vue&type=template&id=784499df&scoped=true&"
import script from "./TopfansBrightpoint.vue?vue&type=script&lang=js&"
export * from "./TopfansBrightpoint.vue?vue&type=script&lang=js&"
import style0 from "./TopfansBrightpoint.vue?vue&type=style&index=0&id=784499df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784499df",
  null
  
)

export default component.exports